export const ptBR_globalTips = {
  'global.title.notfound': 'Desculpe, a página que você visitou não existe.',
  'global.title.backHome': 'Voltar para casa',
  'global.title.error': 'Ocorreu um erro, tente novamente mais tarde',
  'global.title.download': 'Download',
  'global.title.more.filter': 'Mais filtros',
  'global.title.less.filter': 'Menos filtros',
  'global.title.clean.filter': 'Limpar filtro',
  'global.title.notification': 'Notificação',
  'global.title.range.date': 'Intervalo de datas',
  'global.title.search': 'Pesquisar',
  'global.title.media': 'Mídia',
  'global.title.all.male': 'Todos',
  'global.title.all': 'Todos',
  'global.title.channel': 'Canal',
  'global.title.condition': 'Condição',
  'global.title.resolution': 'Resolução',
  'global.title.tags': 'Tags',
  'global.title.device': 'Dispositivo',
  'global.title.host': 'URL de origem',
  'global.title.country': 'País',
  'global.title.city': 'Cidade',
  'global.title.satisfaction': 'Satisfação',
  'global.title.date': 'Data',
  'global.title.user': 'Usuário',
  'global.title.unknown': 'Desconhecido',
  'global.title.interactions': 'Interações',
  'global.title.not.response': 'Sem response',
  'global.title.actions': 'Ações',
  'global.title.without': 'Sem',
  'global.title.with': 'Com',
  'global.title.today': 'Hoje',
  'global.title.yesterday': 'Ontem',
  'global.title.this.week': 'Esta semana',
  'global.title.last.week': 'Semana passada',
  'global.title.last.30.days': 'Últimos 30 días',
  'global.title.this.month': 'Este mês',
  'global.title.last.month': 'Mês passado',
  'global.title.this.quarter': 'Este trimestre',
  'global.title.last.quarter': 'Trimestre passado',
  'global.title.this.year': 'Este ano',
  'global.title.empty': 'Não há registros',
  'global.title.back': 'Retorna',
  'global.title.spotter.title': 'Explore o poder dos seus dados com o Spotter, seu analista com IA.',
  'global.title.spotter.description': 'Com o Spotter, você pode obter insights fazendo perguntas diretas sobre seus dados e receber instantaneamente respostas claras, visualizações dinâmicas e recomendações inteligentes.'
};
